/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { FormDataResult } from './DataResult';

import BoxUpload from '../components/Upload';

import {
  Container,
  Left,
  Right,
  BoxInstructions,
  BoxSendtoPanel,
  SendButton,
  ErrorButton,
  ProgressUpload,
  IconCSV,
  BoxProgress,
  PercentageSize,
  ProgressLoading,
} from './styles';

import cvs_icon from '~/assets/img/cvs-icon.svg';
import cvs_icon_error from '~/assets/img/cvs-icon-error.svg';
import success_icon from '~/assets/img/sucess.svg';
import error_icon from '~/assets/img/error-icon.svg';
import circle_icon from '~/assets/img/circle.svg';
import circle_icon_error from '~/assets/img/circle-error.svg';

import templateCsv from '~/assets/template_indicadores_gerais_v1.csv';
import templateCsv2 from '~/assets/template_indicadores_gerais_v2.csv';

const FileAnalysisCompleted = ({
  fileData,
  handleSelectFile,
  handleSubmit,
  originalName,
  errorCompetence,
  errorCnes,
  setErrorFile,
  periodoSelecionado,
  anoSelecionado
}) => {
  const { errorData, loading } = useSelector(state => state.generalIndicator);

  function beforeunload(e) {
    if (!errorCompetence || !errorCnes) {
      e.preventDefault();
      e.returnValue = true;
    }
  }
  function callHandleSubmit() {
    window.removeEventListener('beforeunload', beforeunload);
    setTimeout(() => {
      handleSubmit();
    }, 200);
  }

  const scrollToErrors = () => {
    window.scrollTo({ top: 830, left: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('beforeunload', beforeunload);
  }, []);

  return (
    <>
      <Container>
        {errorCompetence || errorCnes || errorData ? (
          <Left>
            <BoxUpload
              id="BoxUpload"
              handleSelectFile={handleSelectFile}
              setErrorFile={setErrorFile}
              isResend
            />
            {anoSelecionado <= Number.parseInt('2023')? (<BoxInstructions>
              <span>Dúvidas sobre o padrão requerido?</span>
              <p>
                <a
                  href={templateCsv}
                  target="_blank"
                  rel="noreferrer noopener"
                  title="Baixe aqui o template do arquivo CSV com instruções."
                  download="template_indicadores_gerais_v1.csv"
                >
                  Baixe aqui o template do arquivo
                  <br /> CSV com instruções.
                </a>
              </p>
            </BoxInstructions>) : (
              <BoxInstructions>
              <span>Dúvidas sobre o padrão requerido?</span>
              <p>
                <a
                  href={templateCsv2}
                  target="_blank"
                  rel="noreferrer noopener"
                  title="Baixe aqui o template do arquivo CSV com instruções."
                  download="template_indicadores_gerais_v2.csv"
                >
                  Baixe aqui o template do arquivo
                  <br /> CSV com instruções.
                </a>
              </p>
            </BoxInstructions>
            )
            }            
          </Left>
        ) : null}
        <Right>
          <BoxSendtoPanel>
            <ProgressUpload>
              {errorCompetence || errorCnes || errorData ? (
                <span className="analysisTitle error">Envio recusado!</span>
              ) : (
                <>
                  <span className="analysisTitle">Análise concluída</span>
                  <p>
                    Os dados somente serão enviados após clicar no botão "Enviar
                    para o painel".
                  </p>
                </>
              )}

              <div className="bodyProgress">
                <IconCSV>
                  <img
                    src={
                      errorCompetence || errorCnes || errorData
                        ? cvs_icon_error
                        : cvs_icon
                    }
                    alt=""
                  />
                  <img
                    src={
                      errorCompetence || errorCnes || errorData
                        ? circle_icon_error
                        : circle_icon
                    }
                    alt=""
                  />
                </IconCSV>
                <BoxProgress error={errorCompetence || errorCnes || errorData}>
                  <div className="titleProgress">
                    <p>
                      {errorCompetence || errorCnes
                        ? originalName
                        : 'Arquivo carregado'}
                    </p>
                    <img
                      src={
                        errorCompetence || errorCnes || errorData
                          ? error_icon
                          : success_icon
                      }
                      alt=""
                    />
                  </div>
                  <ProgressLoading
                    error={errorCompetence || errorCnes || errorData}
                  />
                  <PercentageSize
                    error={errorCompetence || errorCnes || errorData}
                  >
                    <p>
                      {errorCompetence || errorCnes || errorData
                        ? 'Incompleto'
                        : '100% completo'}
                    </p>
                  </PercentageSize>
                </BoxProgress>
              </div>
            </ProgressUpload>

            {errorCompetence || errorCnes || errorData ? (
              <ErrorButton>
                <button type="button" onClick={() => scrollToErrors()}>
                  Ver inconsistências
                </button>
              </ErrorButton>
            ) : (
              <SendButton>
                <button
                  type="button"
                  onClick={!loading ? callHandleSubmit : null}
                >
                  {loading ? 'Enviando...' : 'Enviar para o painel'}
                </button>
                <span>
                  É importante a conferência dos dados antes de enviar. <br />
                  (Para conferir, role a página para baixo)
                </span>
              </SendButton>
            )}
          </BoxSendtoPanel>
        </Right>
      </Container>

      <FormDataResult
        data={fileData}
        errorCompetence={errorCompetence}
        errorCnes={errorCnes}
      />
    </>
  );
};

FileAnalysisCompleted.propTypes = {
  fileData: PropTypes.objectOf(PropTypes.string).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  originalName: PropTypes.string.isRequired,
  errorCompetence: PropTypes.bool.isRequired,
  errorCnes: PropTypes.bool.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
  setErrorFile: PropTypes.func.isRequired,
  anoSelecionado: PropTypes.string
};

export default FileAnalysisCompleted;
